import React from 'react';
import download from '../../assets/img/icons/download.svg';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import ConfigUrl from '../../config/config-url';
import GIELink from "../../components/GIELink/GIELink";

export default class DownloadPdf extends React.Component<any, any> {
  configUrl: ConfigUrl = new ConfigUrl();

  downloadMandate = () => {
    window.open(this.configUrl.getBaseBackUrlStatic() + '/bank/Demande de prélévement SEPA.pdf');
  }

  render() {
    return (
      <div className="text-center my-5">
        <div>
          Pour finaliser la mise en place du prélèvement automatique, merci de bien vouloir télécharger, imprimer et
          compléter le mandat de prélèvement ci-dessous et l’accompagner d’un Relevé d’Identité Bancaire (RIB), à
          adresser par la poste à l’adresse GIE SA, 14 place des Halles, 67000 Strasbourg
        </div>

        <Tooltip title="Télécharger le mandat de prélèvement">
          <GIELink href="javascript:void(0)" onClick={this.downloadMandate} className="fw-bold">
            <span>Demande de prélévement SEPA</span>
            <Icon>
              <img alt="icon" src={download}/>
            </Icon>
          </GIELink>
        </Tooltip>
      </div>
    );
  }
}
